export default __webpack_public_path__ + "static/media/cloud.2f3fca0f.svg";